<template>
  <div>
    <list row-key="id" ref="list" unit="取号日志" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="店铺名称" label-width="105px">
          <el-select v-model="mallId" @change="onMallChange" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.mallId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" label-width="105px">
          <el-select v-model="params.快递公司" placeholder="请选择" clearable>
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单状态" label-width="105px">
          <el-select v-model="params.运单状态" placeholder="请选择" clearable>
            <el-option label="正常" :value="0"></el-option>
            <el-option label="已回收" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取号/回收时间" label-width="105px">
          <range-picker :date="[params.startDate, params.endDate]"
            @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
        </el-form-item>
        <el-form-item label="快速筛选" label-width="105px">
          <el-input v-model="params.快速筛选" placeholder="请输入订单号/运单号/批次号/手机号" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="address" label="批次号" min-width="200px" />
        <el-table-column prop="address" label="店铺" min-width="200px" />
        <el-table-column prop="address" label="订单号" min-width="200px" />
        <el-table-column prop="address" label="打印时间" min-width="200px" />
        <el-table-column prop="address" label="快递/运单号" min-width="200px" />
        <el-table-column prop="address" label="收件信息" min-width="200px" />
        <el-table-column prop="address" label="寄件信息" min-width="200px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      // api: require("@/api/sy/user").default,
      pddApi: {
        logistics: require('@/api/pdd/logistics').default,
      },
      sysType: "",
      mallId: "", //店铺编号
      params: {
        快递公司: "",
        startDate: null,
        endDate: null,
        运单状态: null,
        快速筛选: "",
      },
      companiesList: [],
    };
  },
  created() {
    this.sysType = localStorage.getItem("sys_type");
    var user_info = localStorage.getItem("user-info");
    if (user_info) {
      let user = JSON.parse(user_info);
      let malls = this.$store.state.user.mallList.filter(x => x.day >= 0 && x.mallId == user.mallId);
      if (malls.length > 0) this.mallId = malls[0].mallId;
    }
    this.getCompanies();
  },
  computed: {
    mallList() {
      return this.$store.state.user.mallList.filter(x => x.day >= 0);
    }
  },
  methods: {
    onMallChange() {
      this.params.快递公司 = "";
      this.companiesList = [];
      this.getCompanies();
    },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.companies(this.mallId).then(res => {
          if (!res.errorCode) this.companiesList = res.data;
          resolve(res);
        }).catch((err) => { })
      })
    },
    getDataFunc(params) {
      // params = this.$commonJs.obj.removeNullKey({
      //   ...params,
      //   OrderType: this.quickSearch,
      //   SnField: this.snField,
      //   SnType: this.snType,
      //   [this.params.fieldType]: this.params.fieldValue
      // })
      return new Promise((resolve, reject) => {
        console.log("获取数据");
        resolve({ Code: 0, data: [], Msg: null })
        // this.api.list(params).then(res => {
        //   console.log("getDataFunc", params)
        //   resolve(res)
        // })
      })
    },
  },
};
</script>